module.exports = __webpack_public_path__ + "static/media/people.4a26a6f5.jpg";